import {Eventify} from './Eventify.js';
import {PollModel} from './PollModel.js';
import {PollResultsUpdateContainer} from './PollResultsUpdateContainer.js';
import {PollRobotTemplate} from './PollRobotTemplate.js';
import {UserDetailTable as _} from './UserDetailTable.js';

export class PollEdit extends HTMLElement {
	constructor() {
		super();
		// this.model = pollModel;
		// We should retrieve the pollmodel from the server in some fashion
		this.model = new PollModel(0,0,``);
		this.model.addListener(this);

		this.shadow = this.attachShadow({mode:'open'});
		this.showingpoll = false;
		this.showingresults = false;
	}
	back_to_polls(evt) {
		evt.preventDefault(); evt.stopPropagation();
		this.dispatchEvent(new CustomEvent(`pollrobot-show-folders`, {
			bubbles: true, composed: true, detail: {}
		}));
	}
	setModel(model) {
		if (this.model) {
			this.model.removeListener(this);
		}
		this.model = model;
		this.model.addListener(this);
		this.$.title.value = model.title;
		for (let q of model.questions) {
			this.question_added(q);
		}
	}
	title_changed(evt) {
		this.model.setPoll(this.$.title.value);
	}
	debug_poll(evt) {
		console.log(`model = `, this.model);
		// let o = this.model.object();
		// console.log(JSON.stringify(o));
	}
	connectedCallback() {
		[this.el, this.$] = PollRobotTemplate(`PollEdit`);
		this.shadow.appendChild(this.el);
		this.$.add_question.addEventListener(`click`, evt=>{
			evt.preventDefault(); evt.stopPropagation();
			this.model.addQuestion(0,0,`single`,``);
		});

		this.pollResultsUpdateContainer = new PollResultsUpdateContainer();
		this.pollResultsUpdateContainer.addListener(this);

		Eventify(this.shadow, this);

		if (this.hasAttribute(`data-poll-js`)) {
			let jdom = document.getElementById(this.getAttribute(`data-poll-js`));
			if (jdom) {
				let js = JSON.parse(jdom.innerText);
				this.model.fromObject(js);
				this.$.title.value = this.model.title;
			}
		}
		this.token = this.getAttribute(`token`);
		
	}
	question_added(qm) {
		let qe = new QuestionEdit(el=>{
			this.$.questions.insertBefore(el, this.$.controls);
		}, qm);
		// todo can update poll information here - although update
		// should occur with a 'Save' button instead I think...
	}
	question_removed(qm) {
		// console.log(`PollEdit.question_removed`);
	}
	poll_changed(pm) {
		// console.log(`PollEdit.poll_changed`);
	}
	take_poll(evt) {
		evt.preventDefault(); evt.stopPropagation();
		let display = document.getElementById(`display`);
		display.innerHTML = ``;
		new AnswerPoll(display, this.model);
	}
	getChannel() {
		return this.getAttribute(`channel`);
	}
	show_poll(evt) {
		if (this.showingpoll){
			return;
		}
		this.showingpoll = true;
		this.$.showpollbutton.style.display = "none";
		this.$.closepollbutton.style.display = "";
		console.log(`showing poll on channel ${this.getChannel()}: `, this.model);
		evt.preventDefault(); evt.stopPropagation();
		// @TODO Add user clientKey to the model
		// fetch _must get_ the URL for the poll server
		fetch(this.url(`/poll/show/${this.getChannel()}/js?token=${encodeURIComponent(this.getAttribute('token'))}`), {
			method: 'post',
			body: JSON.stringify(this.model.object()),
		})
		.then( res=>res.json() )
		.then( js=>{
			console.log(`PollEdit.show_poll returned `, js);
			this.model.updateFromSaved(js);
			this.pollResultsUpdateContainer.showLiveResults(js);
		})
		.catch(err=>this.doError(err));
	}
	view_results_table(evt) {
		evt.stopPropagation();
		const tableUrl = this.url(`/poll/result/${this.model.id}/latest/table?token=${encodeURIComponent(this.getAttribute('token'))}`);
		// this.$.userdetaildialog.showModal();
		this.$.userdetailtable.loadTable(tableUrl);
	}
	update_container_close_poll(pollId, askId) {
		this.close_poll(null);
	}
	save_poll(evt) {
		console.log(`saving poll`);
		evt.preventDefault();
		evt.stopPropagation();
		fetch(this.url(
			`/poll/save/${this.getAttribute(`folder`)}/js` + 
			`?token=${encodeURIComponent(this.getAttribute(`token`))}`), {
			method: `POST`,
			body: JSON.stringify(this.model.object()),
		})
		.then( res=>res.json() )
		.then( js=>{
			this.model.updateFromSaved(js);
			return Promise.resolve(true);
		})
		.catch(err=>this.doError(err));
	}
	show_results(evt) {
		if (this.showingresults){
			return;
		}
		this.showingresults = true;
		this.$.showresultsbutton.style.display = "none";
		this.$.closeresultsbutton.style.display = "";
		evt.preventDefault(); evt.stopPropagation();
		console.log(`show_results: model=`, this.model);
		fetch(this.url(
				`/poll/show-result/${this.getChannel()}/${this.model.id}` + 
				`?token=${encodeURIComponent(this.getAttribute(`token`))}`))
		.then( res=>res.json() )
		.then( js=> {
			console.log(`show_results returned `, js);
			return Promise.resolve(true);
		})
		.catch(err=>this.doError(err));
	}
	close_results(evt) {
		if (!this.showingresults){
			return;
		}
		evt.preventDefault(); evt.stopPropagation();
		this.showingresults = false;
		this.$.showresultsbutton.style.display = "";
		this.$.closeresultsbutton.style.display = "none";
		fetch(this.url(
				`/poll/close-result/${this.getChannel()}/${this.model.id}` + 
				`?token=${encodeURIComponent(this.getAttribute(`token`))}`))
		.then( res=>res.json() )
		.then( js=> {
			console.log(`show_results returned `, js);
			return Promise.resolve(true);
		})
		.catch(err=>this.doError(err));
	}
	url(path) {
		return (this.hasAttribute(`api-url`)?this.getAttribute(`api-url`):"") +
			path;
	}
	close_poll(evt) {
		if (!this.showingpoll){
			return;
		}
		if (evt) {
			evt.preventDefault(); evt.stopPropagation();
		}
		this.showingpoll = false;
		this.$.showpollbutton.style.display = "";
		this.$.closepollbutton.style.display = "none";
		fetch(this.url(`/poll/close/${this.getChannel()}/js`), {})
		.catch(err=>this.doError(err));
		// @TODO Check for errors on fetch
	}
	doError(err) {
		console.log(err);
		alert(err);
	}
}

class QuestionEdit {
	constructor(insertFn, qm) {
		this.model = qm;
		this.model.addListener(this);
		[this.el, this.$] = PollRobotTemplate(`QuestionEdit`);

		this.$.add_option.addEventListener(`click`, evt=>{
			evt.stopPropagation(); evt.preventDefault();
			this.model.addOption(0,0,``);			
		});
		this.$.del.addEventListener(`click`, evt=>{
			evt.stopPropagation(); evt.preventDefault();
			this.model.remove();
		});
		// setup this question
		this.$.text.innerText = this.model.text;
		if (this.model.isSingleSelectType()) {

		}
		/* Set question type based on js */
		this.displaySelectType(this.model.qtype);

		Eventify(this.el, this);
		for (let o of this.model.options) {
			this.option_added(o);
		}
		insertFn(this.el);
	}
	keyup(evt) {
		// Chrome causes <space> to toggle the detail/summary unless we 
		// prevent it in the input field
		evt.preventDefault();
	}
	displaySelectType(val) {
		for (let i=0; i<this.$.qtype.options.length; i++) {
			if (this.$.qtype.options[i].value==val) {
				this.$.qtype.selectedIndex = i;
				break;
			}
		}
	}
	question_text_changed(evt) {
		evt.preventDefault(); evt.stopPropagation();
		console.log(`question_text_changed`);
		this.model.setModelText(this.$.text.value);
	}
	question_type_changed(evt) {
		this.model.setModelQuestionType(this.$.qtype.item(this.$.qtype.selectedIndex).value);
	}
	option_added(om) {
		new OptionEdit(el=>this.$.options.insertBefore(el, this.$.controls), om);
		om.addListener(this);
	}
	option_removed(om) {
		om.removeListener(this);
	}
	option_changed(om) {
		// option_changed at this point is called when the option 
		// text changes, but I can ignore this for a UI level for 
		// now. If we later add undo/redo, we must support this
	}
	question_changed(qm) {}
	question_removed(qm) {
		// question_removed is triggered after I am clicked
		this.model.removeListener(this);
		this.el.remove();
	}
}

class OptionEdit {
	constructor(insertFn, optionModel) {
		this.model = optionModel;
		this.model.addListener(this);
		[this.el, this.$] = PollRobotTemplate(`OptionEdit`);
		insertFn(this.el);
		this.$.del.addEventListener(`click`, evt=>{
			evt.preventDefault(); evt.stopPropagation();
			this.model.remove();
		});
		this.$.option.value = this.model.text;
		Eventify(this.el, this);
		this.$.option.focus();
	}
	option_text_changed(evt) {
		evt.preventDefault(); evt.stopPropagation();
		this.model.setOption(this.model.num, this.$.option.value);
	}
	option_changed(om) {
		// ignore for now
	}
	option_removed(om) {
		this.model.removeListener(this);
		this.el.remove();
	}
}

customElements.define(`pollrobot-edit`, PollEdit);